/**
 * Format a date string to Persian format
 * @param dateString - The date string to format
 * @returns Formatted date string in Persian format
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return '-';

  try {
    // Date-only YYYY-MM-DD must not use UTC midnight parsing
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return formatYmdPersian(dateString);
    }
    const date = new Date(dateString);
    return date.toLocaleDateString('fa-IR');
  } catch (error) {
    return dateString;
  }
};

/**
 * Parse YYYY-MM-DD as a local calendar day (noon) to avoid UTC day shifts.
 */
export const parseYmdLocal = (ymd: string): Date => {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, m - 1, d, 12, 0, 0);
};

/**
 * Format a YYYY-MM-DD calendar day in Persian without UTC off-by-one.
 */
export const formatYmdPersian = (
  ymd?: string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
): string => {
  if (!ymd) return '-';
  try {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
      return new Intl.DateTimeFormat('fa-IR', options).format(new Date(ymd));
    }
    return new Intl.DateTimeFormat('fa-IR', options).format(parseYmdLocal(ymd));
  } catch {
    return ymd;
  }
};
